export default {
  title: "Змінити профіль",
  form: {
    avatar_image_url: {
      label: "Аватар",
      btn_modal_open: "Оновити зображення профілю",
      modal: {
        label_btn: 'зображення профілю',
        btn_modal_open: 'Оновити зображення профілю',

        modal_title: 'Оновити зображення профілю',
        modal_description: 'Завантажте зображення або згенеруйте випадкове.',

        file_title: 'Завантажити',
        file_label: 'Оберіть файл для завантаження',
        file_description: 'Допустимі формати: *.jpg, *.png. Max file size 4Mb.',

        generate_title: 'Згенерувати',
        btn_generate: 'Згенерувати випадкове зображення',

        widget_otp_name: 'Оновлення зображення профілю користувача',

        submit: 'Зберегти зміни',
        saving_changes: 'Збереження змін...',
      },
    },
    name: {
      label: "Ім'я",
    },
    first_name: {
      label: "Ім'я",
      placeholder: "Введіть Ваше Ім'я",
    },
    last_name: {
      label: "Призвище",
      placeholder: "Введіть Ваше прізвище",
    },
    timezone: {
      label: "Часовий пояс",
      placeholder: "Введіть місце",
    },
    button: {
      close: "Закрити",
      save: "Зберегти",
    },
  },
}
